import { useEffect } from "react"
import { useIntersectionObserver } from "usehooks-ts"

export function useOnVisible(callback: () => void) {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.25,
    freezeOnceVisible: true,
  })

  useEffect(() => {
    callback()
  }, [isIntersecting])

  return ref
}
